export const quizQuestions = [
  {
    q: 'How much of your team’s week goes to repetitive administrative tasks?',
    options: ['More than half', 'About a third', 'Some, but it’s manageable', 'Very little—most is already streamlined'],
  },
  {
    q: 'How clearly are your core processes documented?',
    options: ['They live in people’s heads', 'Partly documented, inconsistently followed', 'Documented for most key processes', 'Clearly documented and regularly reviewed'],
  },
  {
    q: 'How connected are the tools and systems your team uses?',
    options: ['Mostly spreadsheets, email, and paper', 'Several tools that don’t talk to each other', 'Some tools are integrated', 'Well integrated, with data flowing between them'],
  },
  {
    q: 'How does your team typically respond to new technology?',
    options: ['Hesitant or resistant', 'Open, but slow to adopt', 'Generally willing with good training', 'Eager and quick to adapt'],
  },
  {
    q: 'Where is your organization with artificial intelligence?',
    options: ['Not using it, unsure where to start', 'A few individuals experimenting', 'Some intentional use in specific areas', 'Guided use with clear policies and oversight'],
  },
  {
    q: 'How aligned is leadership on making time and budget for process improvement?',
    options: ['Not yet a priority', 'Interested, but no plan', 'Committed, with a few initiatives underway', 'Fully committed with dedicated resources'],
  },
];

export const quizLevel = (score) => {
  if (score >= 70) return {
    level: 'Ready to Scale',
    message: 'You have a strong foundation. The opportunity now is to connect your systems, automate with intention, and integrate AI responsibly so your people can focus on higher-value work.',
  };
  if (score >= 40) return {
    level: 'Building Momentum',
    message: 'You have real pieces in place. Clarifying processes, connecting tools, and supporting adoption will help you turn scattered efforts into consistent, sustainable results.',
  };
  return {
    level: 'Laying the Foundation',
    message: 'This is the ideal starting point. Before adding technology, we help you understand the work, simplify what slows your team down, and build readiness so new systems actually stick.',
  };
};
